/** What an auto-arrange preview would change; lanes and sequences only exist on some canvases. */
export interface LayoutPreviewChanges {
  nodes: number
  lanes?: number
  sequences?: number
}

export const hasLayoutChanges = ({
  nodes,
  lanes = 0,
  sequences = 0,
}: LayoutPreviewChanges): boolean => nodes + lanes + sequences > 0

const countOf = (count: number, singular: string, plural: string): string =>
  `${count} ${count === 1 ? singular : plural}`

/** The one-line status shown in the layout preview bar. */
export function layoutPreviewSummary(
  changes: LayoutPreviewChanges,
  state: {
    stale: boolean
    applying: boolean
    /** The preview is being planned again (Refresh). */
    planning?: boolean
  }
): string {
  if (state.applying) {
    return 'Saving the new layout…'
  }
  if (state.planning) {
    return 'Preparing the preview…'
  }
  if (state.stale) {
    return 'The diagram changed since this preview was made.'
  }
  if (!hasLayoutChanges(changes)) {
    return 'Already arranged — nothing to change.'
  }
  const { nodes, lanes = 0, sequences = 0 } = changes

  return [
    nodes && countOf(nodes, 'node moved', 'nodes moved'),
    lanes && countOf(lanes, 'lane resized', 'lanes resized'),
    sequences && countOf(sequences, 'sequence redrawn', 'sequences redrawn'),
  ]
    .filter(Boolean)
    .join(' · ')
}
